export class RefModeConduite {
    id: number;
    code: string;
    libelle: string;
}
